import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/slices/authSlice';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Clear any existing auth data and redirect to login
    dispatch(logout());
    const timer = setTimeout(() => {
      navigate('/signin');
    }, 2000); // Redirect after 2 seconds

    return () => clearTimeout(timer);
  }, [dispatch, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Session Expired
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Your session has expired or you don't have permission to access this page.
          </p>
          <p className="mt-2 text-sm text-gray-500">
            Redirecting to login page...
          </p>
        </div>
        <div className="mt-8">
          <button
            onClick={() => navigate('/signin')}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-themeOrange hover:bg-themeOrange-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-themeOrange"
          >
            Go to Login Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;